import React from "react"
import { useEmptyStyles } from "./style"
import { useEmptyItem } from "Components/Preset/EmptyItem/hook"
import { WeekDay } from "Components/Preset/context"
import { PresetPlace } from "Types/place"

export interface ComponentProps {
    weekDay: WeekDay,
    place: PresetPlace,
}

export default (props: ComponentProps) => {
    const classes = useEmptyStyles()
    const {
        handleAddPreset,
    } = useEmptyItem(props)
    return (
        <div
            className={classes.root}
            onClick={handleAddPreset}
        />
    )
}

